import { render } from "./AppMobile.vue?vue&type=template&id=5d227b12&scoped=true"
import script from "./AppMobile.vue?vue&type=script&lang=js"
export * from "./AppMobile.vue?vue&type=script&lang=js"

import "./AppMobile.vue?vue&type=style&index=0&id=5d227b12&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d227b12"]])

export default __exports__